import React, { Component } from "react";
import {
  View,
  ScrollView,
  TouchableHighlight,
  KeyboardAvoidingView,
} from "react-native";
import Text from "../components_v2/TextFont";

import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import { faCheckSquare, faSquare } from "../../assets/consts/faCharCodes";

import Theme from "../argon-ui/Theme";
import { connect } from "react-redux";
import { IS_WEB, translate } from "../locales/translate";
import * as Actions from "../actions/AreaActions";
import { ArButton } from "../argon-ui";
import Loading from "../components/Loading";
import * as AreaHelper from "../actions/AreaHelper";
import InputSearch from "../components_v2/InputSearch";
// const findAreaById = (allAreas, areaId) => {
//   var oldArea = null;

//   for (var i in allAreas) {
//     if (allAreas[i].areaId == areaId) {
//       oldArea = { ...allAreas[i] };
//       break;
//     }
//   }
//   return oldArea;
// };

// const findMainParent = (allAreas, currentArea) => {
//   if (currentArea.parentAreaId) {
//     var prnt = findAreaById(allAreas, currentArea.parentAreaId);
//     if (prnt.isMainArea) {
//       return prnt;
//     } else {
//       return this.findMainParent(prnt);
//     }
//   }
//   return null;
// };

class DeviceToAreaScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      ...this.props.navigation.state.params,
      rootAreaId: null,
      searchTerm: "",
      checkedItems: [],
      checkedItemsUId: [],
      accessToken: null,
    };

    // model is tree area list start with a IsMainArea node. children contain areaId, areaName, parentAreaId, subAreas
    this.model = {};
    this.oldArea = {};
    this.allAreas = [];
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.AreasList"),
  });
  componentDidMount() {
    const accessToken = this.props.appReducer?.currentServer.accessToken;
    this.props.resetTransportResult();
    this.allAreas = [...this.props.areaReducer.areas];
    // if oldAreaId passed, show only related tree.
    // if (this.state.oldAreaId || this.state.oldAreaUId) {
    //   this.oldArea = AreaHelper.findAreaById(
    //     this.allAreas,
    //     this.state.oldAreaId || this.state.oldAreaUId
    //   );
    //   if (this.oldArea) {
    //     if (this.oldArea.isMainArea) {
    //       // if is main, find children recursively (tree).
    //       // this.model = this.oldArea;
    //       this.model = AreaHelper.GetTree(this.allAreas);
    //       this.setState({
    //         rootAreaId: this.state.areaId,
    //       });
    //     } else {
    //       const _rooAreaUId = this.model.areaId || this.model.areaUId;
    //       // if is not main, find nearest main parent.
    //       if (this.oldArea.parentAreaId || this.oldArea.parentAreaUId) {
    //         this.model = AreaHelper.findMainParent(this.allAreas, this.oldArea);
    //         this.setState({
    //           rootAreaId: _rooAreaUId,
    //         });
    //       } else {
    //         // this.model = this.oldArea;
    //         this.model = AreaHelper.GetTree(this.allAreas);
    //         this.setState({ rootAreaId: _rooAreaUId });
    //       }
    //     }
    //   }
    //   // else if no oldAreaId passed, show all available
    // } else {
    // }
    this.model = AreaHelper.GetTree(this.allAreas);
    console.log("this.model", this.model);
    this.setState({ isLoading: false, accessToken });
  }

  componentWillUnmount() {
    this.props.resetTransportResult();
  }

  addToCheckedList = (areaId, areaUId) => {
    if (this.state.checkedItems.indexOf(areaId) < 0) {
      var newList = [...this.state.checkedItems];
      newList.push(areaId);
      this.setState({ checkedItems: newList });
    }
    if (this.state.checkedItemsUId.indexOf(areaUId) < 0) {
      var newList = [...this.state.checkedItemsUId];
      newList.push(areaUId);
      this.setState({ checkedItemsUId: newList });
    }
  };

  removeFromCheckedList = (areaId, areaUId) => {
    if (this.state.checkedItems.indexOf(areaId) >= 0) {
      var newList = [...this.state.checkedItems];
      newList.splice(this.state.checkedItems.indexOf(areaId), 1);
      this.setState({ checkedItems: newList });
    }
    if (this.state.checkedItemsUId.indexOf(areaUId) >= 0) {
      var newList = [...this.state.checkedItemsUId];
      newList.splice(this.state.checkedItemsUId.indexOf(areaUId), 1);
      this.setState({ checkedItemsUId: newList });
    }
  };

  handleTransport = () => {
    this.setState({ isLoading: true });
    let {
      devices,
      devicesUId,
      checkedItems,
      checkedItemsUId,
      oldAreaId,
      oldAreaUId,
      accessToken,
    } = this.state;
    if (this.state.transport == "copy") {
      this.props.copyDevicesTo(
        devices,
        devicesUId,
        checkedItems,
        checkedItemsUId,
        oldAreaId,
        oldAreaUId,
        accessToken
      );
    } else if (this.state.transport == "move") {
      this.props.moveDevicesTo(
        devices,
        devicesUId,
        checkedItems,
        checkedItemsUId,
        oldAreaId,
        oldAreaUId,
        accessToken
      );
    }
    setTimeout(() => {
      this.setState({
        isLoading: false,
        checkedItems: [],
        checkedItemsUId: [],
      });
    }, 1000);
  };

  render() {
    if (this.props.areaReducer.isLoading || this.state.isLoading) {
      return <Loading message={translate("app.pleaseWaite")} />;
    }
    return (
      <View style={{ flex: 1 }}>
        <KeyboardAvoidingView style={{ flex: 1 }} behavior="height" enabled>
          <Text style={{ padding: 5 }}>
            {translate("device." + this.state.transport + "DeviceHeader")}{" "}
            {this.oldArea ? this.oldArea.areaName || "" : ""}{" "}
            {translate("app.to")} :
          </Text>
          <ScrollView>
            <View style={{ padding: 5, marginVertical: 5 }}>
              <InputSearch
                placeholder=""
                value={this.state.searchTerm}
                onChangeText={(txt) => {
                  this.setState({
                    searchTerm: txt,
                  });
                }}
              />
            </View>
            <View style={{ flex: 1, paddingHorizontal: 5 }}>
              {this.allAreas.length > 0 && (
                <AreaSelectItem
                  model={this.model || {}}
                  allAreas={[...this.allAreas]}
                  oldAreaId={this.state.oldAreaId}
                  disabled={
                    this.state.oldAreaId == this.model.areaId ||
                    this.model.areaId <= 0
                  }
                  onSelect={(areaId, areaUId) => {
                    this.addToCheckedList(areaId, areaUId);
                  }}
                  onDeselect={(areaId, areaUId) => {
                    this.removeFromCheckedList(areaId, areaUId);
                  }}
                  searchTerm={this.state.searchTerm}
                  style={{ flex: 1 }}
                />
              )}
            </View>
          </ScrollView>
          <View style={{ width: "100%", paddingHorizontal: 5 }}>
            <Text
              style={{
                color: this.props.areaReducer.isTransportCompleted
                  ? Theme.COLORS.SUCCESS
                  : Theme.COLORS.ERROR,
                textAlign: "center",
                marginBottom: 5,
              }}
            >
              {this.props.areaReducer.isTransportCompleted == true
                ? translate("area.transferCompleted")
                : this.props.areaReducer.isTransportCompleted == false
                ? translate("area.transferFailed")
                : ""}
            </Text>
            <ArButton
              color={this.state.checkedItems.length <= 0 ? "muted" : "primary"}
              style={{ width: "100%" }}
              disabled={this.state.checkedItems.length <= 0}
              onPress={() => this.handleTransport()}
            >
              <Text
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  color: Theme.COLORS.WHITE,
                }}
              >
                {translate("app." + this.state.transport)}
              </Text>
            </ArButton>
          </View>
        </KeyboardAvoidingView>
      </View>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    areaReducer: state.AreaReducer,
    deviceReducer: state.DeviceReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    copyDevicesTo: (
      devices,
      devicesUId,
      areas,
      areasUId,
      oldAreaId,
      oldAreaUId,
      accessToken
    ) =>
      dispatch(
        Actions.copyDevicesTo(
          devices,
          devicesUId,
          areas,
          areasUId,
          oldAreaId,
          oldAreaUId,
          accessToken
        )
      ),
    moveDevicesTo: (
      devices,
      devicesUId,
      areas,
      areasUId,
      oldAreaId,
      oldAreaUId,
      accessToken
    ) =>
      dispatch(
        Actions.moveDevicesTo(
          devices,
          devicesUId,
          areas,
          areasUId,
          oldAreaId,
          oldAreaUId,
          accessToken
        )
      ),
    resetTransportResult: () => dispatch(Actions.resetTransportResult()),
  };
};

class AreaSelectItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false,
    };
    this.allAreas = [...this.props.allAreas];
  }
  handleOnPress = (areaId, areaUId) => {
    if (!this.props.disabled) {
      if (this.state.isChecked) {
        this.setState({ isChecked: false });
        this.handleOnDeselect(areaId, areaUId);
      } else {
        this.setState({ isChecked: true });
        this.handleOnSelect(areaId, areaUId);
      }
    }
  };
  handleOnSelect = (areaId, areaUId) => {
    (areaId || areaUId) &&
      this.props.onSelect &&
      this.props.onSelect(areaId, areaUId);
  };

  handleOnDeselect = (areaId, areaUId) => {
    (areaId || areaUId) &&
      this.props.onDeselect &&
      this.props.onDeselect(areaId, areaUId);
  };
  render() {
    return (
      <View
        style={[
          {
            marginBottom: 5,
          },
        ]}
      >
        {this.props.model.areaId > 0 && (
          <TouchableHighlight
            style={{ ...this.props.style }}
            underlayColor="#f2f2f2"
            onPress={() => {
              this.handleOnPress(
                this.props.model.areaId,
                this.props.model.areaUId
              );
            }}
          >
            <View
              style={{
                flexDirection: "row-reverse",
                alignItems: "center",
                marginBottom: 5,
                backgroundColor: Theme.COLORS.GRAY_LIGHT,
                padding: 10,
                borderRadius: 8,
              }}
            >
              <Text
                style={[
                  { flex: 1 },
                  IS_WEB ? { textAlign: "right" } : { textAlign: "left" },
                ]}
              >
                {this.props.model.areaName}
              </Text>
              <FontAwesomeIcon
                icon={this.state.isChecked ? faCheckSquare : faSquare}
                color={
                  this.props.disabled
                    ? Theme.COLORS.MUTED
                    : Theme.COLORS.PRIMARY
                }
                size={26}
                style={IS_WEB ? { marginLeft: 10 } : { marginRight: 10 }}
              />
            </View>
          </TouchableHighlight>
        )}
        {this.props.model.subAreas && this.props.model.subAreas.length > 0 && (
          <View style={IS_WEB ? { paddingRight: 12 } : { paddingLeft: 12 }}>
            {(typeof this.props.model.areaId == "number"
              ? this.props.model?.subAreas
              : this.props.model.subUAreas
            ).map((sub) => {
              if (sub ? Number(sub) : sub) {
                sub = AreaHelper.findAreaById(this.allAreas, sub || sub) || {};
              }
              var displayItem = "none";
              if (
                !this.props.searchTerm ||
                sub.areaName
                  .toLowerCase()
                  .indexOf(this.props.searchTerm.toLowerCase().trim()) >= 0
              ) {
                displayItem = "flex";
              }
              return (
                <AreaSelectItem
                  key={sub?.areaId || sub.areaUId}
                  model={sub}
                  oldAreaId={this.props.oldAreaId}
                  allAreas={[...this.allAreas]}
                  disabled={(sub.areaId || sub.areaUId) == this.props.oldAreaId}
                  onSelect={(areaId, areaUId) =>
                    this.handleOnSelect(areaId, areaUId)
                  }
                  onDeselect={(areaId, areaUId) =>
                    this.handleOnDeselect(areaId, areaUId)
                  }
                  searchTerm={this.props.searchTerm}
                  style={{ display: displayItem }}
                />
              );
            })}
          </View>
        )}
      </View>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceToAreaScreen);
